module.exports = __webpack_public_path__ + "static/media/award_survivor@2x.f94d6a6b.webp";